import React from 'react';
import CoreComponent from "../../../../Core/CoreComponent";
import settings from '../../Settings/Settings';
import AppbarComponent from '../Appbar/Appbar';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import ErrorSnackbar from '../../../../CommonComponents/ErrorSnackbar/ErrorSnackbar';
import Button from '@mui/material/Button';
import LoadingComponent from '../LoadingComponent/LoadingComponent'
import Pagination from '../../../../CommonComponents/Pagination/PaginationComponent'
import Typography from '@mui/material/Typography';
import {
    Link
  } from "react-router-dom";
export default class UserOrdersComponent extends CoreComponent {

    constructor(props) {
        super(props);
        this.loadComponentsProps()
        this.basicComponentConstants = {
            language: props.getManagerState().language,
            history: props.history,
            user: props.getManagerState().user,
        }
    }

    componentDidMount() {
        this.getUserOrdersAction()
        super.componentDidMount()
    }
    loadComponentsProps() {
        const that = this
        this.setComponentsConstants('AppbarComponent', {
            ...this.basicComponentConstants
        }).setComponentsMethods('AppbarComponent', {
            setManagerState: (object, callback) => {
                that.props.setManagerState(object, callback)
            },
            refreshMainComponent: () => {
                that.refresh()
            },
            getManagerState: () => {
                return that.props.getManagerState()
            },
            changeRoute: (route) => {
                that.props.changeRoute(route)
            },
            getLocalStorage: (storageName) => {
                return that.getLocalStorage(storageName)
            }
        }).setComponentsMethods('Pagination', {
            changePage: (page) => {
                that.changePage(page)
            },
        })
    }

    changePage(page) {
        let endpoint = settings.API_ENDPOINT_USER_ORDERS + "?accountToken=" + this.props.getManagerState().user.tokensHash
        endpoint += '&page=' + page
        this.getSearchAdminOrders(endpoint)
    }

    getUserOrdersAction() {
        let that = this
        let endpoint = settings.API_ENDPOINT_USER_ORDERS + '?accountToken=' + that.getLocalStorage('user').tokensHash
        if(this.props.urlParams && parseInt(this.props.urlParams.page) > 1) {
            endpoint += '&page=' + this.props.urlParams.page
        }
        this.props.setManagerState({userOrders: [], loadingUserOrders: true}, () => {
            that.getSearchAdminOrders(endpoint)
        })
    }


    getSearchAdminOrders(endpoint) {
        this.props.setManagerState({userOrders: [], currentPagination: null, loadingUserOrders: true}, () => {
            this.ajax(settings.API_URL + endpoint,{},"GET", null, (data) => {
                this.props.setManagerState({userOrders: data.items,currentPagination: data.pagination, loadingUserOrders: false})
            })
        })
    }

    getRender() {

        let classes = {
            root: {
              display: 'block',
              margin: '70px auto',
              padding: 8,
              '& > *': {
                margin: 1,
                width: 16,
                height: 16,
              },
            },
            img: {
                maxWidth: '150px',
                maxHeight: '150px'
            },
            proceedToCheckout: {
                textDecoration: 'none',
                display: "block",
                margin: "0 5px",
                width: "100%",
                color: 'inherit'
              },
              rootPaper: {
                maxWidth: 750,
                padding: 8,
                margin: '0 auto'
            },
          };
        this.loadComponentsProps()

        let paginationPattern = window.location.pathname.replace(/page\/[0-9]+[\/]{0,1}/i,'').split('orders')
        paginationPattern[1] = '/page/{{page}}'+ paginationPattern[1]
        paginationPattern = paginationPattern.join('orders')
        return <Paper style={classes.rootPaper}><div style={classes.root} id="rootComponent">
                    <AppbarComponent {...this.buildComponentProps('AppbarComponent')} />
                    <Typography variant="h4" component="h4" style={classes.title}>
                        {this.props.getManagerState().language.LANG_ORDERS} 
                    </Typography>
                    <TableContainer component={Paper}>
                        <Table className={classes.table} aria-label="customized table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>{this.props.getManagerState().language.LANG_ORDERS_ID}</TableCell>
                                    <TableCell>{this.props.getManagerState().language.LANG_ACTIONS}</TableCell>
                                    <TableCell>{this.props.getManagerState().language.LANG_ORDERS_USERS_FIRST_NAME_USERS_LAST_NAME}</TableCell>
                                    <TableCell>{this.props.getManagerState().language.LANG_ORDERS_STATUS} / {this.props.getManagerState().language.LANG_ORDERS_TOTAL}</TableCell>
                                </TableRow>
                            </TableHead>
                        <TableBody>
                            {this.props.getManagerState().userOrders.map((el, idx) => [
                        <TableRow key={idx}>
                            <TableCell padding="checkbox">
                                {el.ordersID}
                            </TableCell>
                            <TableCell>
                            <Link to={"/user/order/"+ el.ordersID + "/" + el.ordersSha} style={classes.proceedToCheckout}>
                                <Button variant="contained" color="primary" fullWidth={true} className={classes.closeButton}>
                                    {this.props.getManagerState().language.LANG_ORDER_DETAILS }
                                </Button>
                            </Link>     
                            </TableCell>
                            <TableCell>
                                {el.usersLastName} {el.usersFirstName} <br /> {el.usersEmail} <br /> {el.ordersEmail}
                            </TableCell>
                            <TableCell>
                                {this.props.getManagerState().language[el.ordersStatusesName]} / {((parseInt(el.ordersTotal) + parseInt(el.ordersDeliveryMethodsPrice)) / 100).toFixed(2)} {this.props.getManagerState().language.LANG_CURRENCY}
                            </TableCell>
                        </TableRow>
                    ])}
                    </TableBody>
                    </Table>
                    </TableContainer>
                    {
                        this.props.getManagerState().loadingUserOrders ?
                        <LoadingComponent />
                        :
                        null
                    }
                    <Pagination  {...this.buildComponentProps('Pagination')} pattern={paginationPattern} pagination={this.props.getManagerState().currentPagination} />
                    {this.props.getManagerState().errors.map((element, index) => { 
                        return <ErrorSnackbar message={element} index={index} key={index} clearErrorMessage={this.props.clearErrorMessage}/>
                     })}
                </div>
                </Paper>
    }
}
